import { z } from 'zod';
/** bcrypt processes only the first 72 BYTES of input — reject anything longer
 *  for clear UX rather than silently truncating. UTF-8 chars can be multi-byte
 *  so we measure in bytes. Use TextEncoder (universal) instead of Buffer
 *  (Node-only) since this schema is shared with the browser bundle. */
const utf8Encoder = new TextEncoder();
export const PasswordSchema = z
    .string()
    .min(8, 'Password must be at least 8 characters')
    .refine((s) => utf8Encoder.encode(s).length <= 72, {
    message: 'Password is too long (max 72 bytes when UTF-8 encoded)',
});
export const LoginRequestSchema = z.object({
    email: z.string().email().max(320),
    password: z.string().min(1).max(256), // intentionally relaxed on length here; the strict bound is enforced at user creation
});
//# sourceMappingURL=auth.schema.js.map